import React, { Dispatch, SetStateAction, FC } from 'react'
import { capitalizeString } from 'lib/helpers'
import styles from './AboutArtist.module.scss'
import Follow from '../header/Follow'
import { replaceBadges } from 'lib/badges'
import useQA from 'hooks/useQA'
import { getAccountData } from '../../selectors'
import { useSelector } from 'react-redux'
type Props = {
  setFollowedUserArray: Dispatch<SetStateAction<ReadonlyArray<number>>>
  followedUserArray: ReadonlyArray<number>
}
const AboutArtistHeader: FC<Props> = ({ followedUserArray, setFollowedUserArray }: Props) => {
  const accountData = useSelector(getAccountData)
  const { firstName, lastName, followersTotal, badges, joinedDate } = accountData
  const { testId } = useQA()
  const capitalizedName = capitalizeString(`${firstName} ${lastName}`)
  const joinedDateObject = new Date(joinedDate * 1000)
  const joinedYear = joinedDateObject.getFullYear()

  return (
    <div className={styles.aboutArtistHeader}>
      <div className={styles.artistInfo} {...testId('about-artist-info')}>
        <p className={styles.title}>About the artist</p>
        <h4 className={styles.name}>{capitalizedName}</h4>
        <div className={styles.badges}>
          <p className={styles.joinedYear}>Joined In {joinedYear}</p>
          {replaceBadges(badges).map(({ image, title }, key) => {
            return (
              <img
                className={styles.badgeImage}
                key={key}
                src={image}
                alt={`link - ${title}`}
                title={title}
              />
            )
          })}
        </div>
      </div>
      <div className={styles.followers}>
        <Follow followedUserArray={followedUserArray} setFollowedUserArray={setFollowedUserArray} />
        <p className={styles.followersText} {...testId('followers-text')}>
          {`(${followersTotal} Followers)`}
        </p>
      </div>
    </div>
  )
}
export default AboutArtistHeader
